/**
 * Ref de variante e-commerce → ref « nue » (sans le suffixe de palier de quantité).
 *
 * Les intégrations éclatent les paliers dans le variantRef, avec DEUX formats
 * observés :
 *  - Medusa (nos storefronts) : `{variantId}_{qty}`      → ex. `variant_01ABC_10`
 *  - Shopify (intégrations partenaires) : `{sku}__qty_{qty}` → ex. `GOGOB033PP00TDGF__qty_1`
 *
 * On retire les deux. Le `(?:__qty)?` optionnel avale le `__qty` de Shopify quand il
 * précède le `_{qty}` final ; sinon on retombe sur le simple `_{qty}` de Medusa. Sans
 * ça, une ref Shopify `..._..._1` n'était strippée qu'en `...__qty` → la garde
 * anti-produit-périmé (RC3) rejetait à tort un payload valide (bug import partenaire).
 */
export function stripTierSuffix(ref: string | null | undefined): string {
    return String(ref ?? '').replace(/(?:__qty)?_\d+$/, '');
}

/** Vrai si la ref porte un suffixe de palier (Medusa `_qty` ou Shopify `__qty_qty`). */
export function hasTierSuffix(ref: string | null | undefined): boolean {
    return /(?:__qty)?_\d+$/.test(String(ref ?? ''));
}
